import React, { useRef, useState, useEffect, useContext } from 'react'
import { useNavigate } from "react-router-dom";
import { UserContext } from '../context/UserContext';
import { formatDatePicker, topFunction } from '../Utils/utils'

export default function Remove() {
    const { user, setUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [confirm, setConfirm] = useState(null)
    const [pending, setPending] = useState(false)

    let companyName = null;

    // DOM References
    const refAction = useRef();
    const refActionError = useRef();
    const refInventory = useRef();
    const refInventoryError = useRef();
    const refPartNum = useRef();
    const refPartNumError = useRef();
    const refName = useRef();
    const refNameError = useRef();
    const refDate = useRef();
    const refDateError = useRef();
    const refDateCharge = useRef();
    const refNextDay = useRef();
    const refPortal = useRef();
    const refPortalError = useRef();
    const refErrors = useRef();
    const refPortalList = useRef();
    const refVeraCore = useRef();
    const refVeraCoreError = useRef();
    const refHoldDate = useRef();

    //Overlay References
    const overlay = useRef();
    const loadingOverlay = useRef();
    const popup = useRef();
    const modalHeading = useRef();
    const modalContent = useRef();
    const modalClose = useRef();
    const popupConfirm = useRef();
    const popupConfirmHeading = useRef();
    const popupConfirmContent = useRef();
    const popupConfirmClose = useRef();

    const [state, setState] = useState({
        action: '', 
        inventory: '', 
        partnum: '', 
        name: '', 
        effective_date: '', 
        next_day: '', 
        client_notes: '',
        vc_product_id:'',
        customer_number:'',
        hold_date: 'no'
    });
    
    const handleChange = e => {
        const { name, value } = e.target;
        
        if(name === "effective_date"){
            refDateCharge.current.classList.remove("show");
            // Next Day Logic
            let nextDay = false;
            const todaysDate = new Date();
            todaysDate.setHours(0,0,0,0);
    
            // Grab entered effective date at midnight
            const eDate = new Date(value + ' 00:00:00');
    
            // Add 1 business day to today's date
            const newDate = new Date(addBusinessDays(todaysDate, 1));
            
            // Date is 1 business day in the future
            if(eDate.getTime() === newDate.getTime()){
                refDateCharge.current.classList.add("show");
            } 
        }
        
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
        // e.target.classList.remove('error-outline');
    };

    // Confirm Modal
    async function confirmOverlay(){
        let text = '<div class="mt10 center">Would you like to enter another request?</div>';

        let scrollbarWidth = window.innerWidth - document.body.clientWidth;
        document.body.style.overflow = "hidden";
        document.body.style.marginRight = scrollbarWidth + 'px';
       
        popupConfirmContent.current.innerHTML = text;
        overlay.current.className = 'show';
        popupConfirm.current.className = 'show';
    }


    // Form Submit & Validation
    async function handleSubmit(){
        let shouldSubmit = true;
        let nextDay = false;

        refAction.current.classList.remove('error-outline');
        refActionError.current.style.display='none';
        refInventory.current.classList.remove('error-outline');
        refInventoryError.current.style.display='none';
        refName.current.classList.remove('error-outline');
        refNameError.current.style.display='none';
        refPartNum.current.classList.remove('error-outline');
        refPartNumError.current.style.display='none';
        refDate.current.classList.remove('error-outline');
        refDateError.current.style.display='none';
        if(user.role === 'admin' || user.role === 'sales'){
            refVeraCore.current.classList.remove('error-outline');
            refVeraCoreError.current.style.display='none';
            refPortal.current.classList.remove('error-outline');
            refPortalError.current.style.display='none';
        }

        if(!refNextDay.current.checked) refDateCharge.current.classList.remove("show");
        refErrors.current.classList.remove('show');

        // Form validation
        if(state.action === '' || state.action.indexOf('Select') !== -1){
            refAction.current.classList.add('error-outline');
            refActionError.current.style.display='block';
            shouldSubmit = false;
        }

        if(state.inventory === '' || state.inventory.indexOf('Select') !== -1){
            // str += 'Please select an inventory option from the dropdown<br />';
            refInventory.current.classList.add('error-outline');
            refInventoryError.current.style.display='block';
            shouldSubmit = false;
        }

        if(state.partnum === ''){
            refPartNumError.current.innerHTML = 'Please enter a part number.';
            refPartNum.current.classList.add('error-outline');
            refPartNumError.current.style.display='block';
            shouldSubmit = false;
        }

        if(state.name === ''){
            refName.current.classList.add('error-outline');
            refNameError.current.style.display='block';
            shouldSubmit = false;
        }

        if(state.effective_date === '' && user.role !== "external"){
            refDateError.current.innerHTML = 'Please enter an effective date.';
            refDate.current.classList.add('error-outline');
            refDateError.current.style.display='block';
            shouldSubmit = false;
        }

        if(state.effective_date !== '' && user.role !== "external"){
            // No Weekends
            let dayNum = new Date(refDate.current.value).getUTCDay();
            if(dayNum === 0 || dayNum === 6){
                refDateError.current.innerHTML = 'Effective date cannot be set to a weekend.';
                refNextDay.current.checked = false;
                refDateCharge.current.style.display='none';
                refDate.current.classList.add('error-outline');
                refDateError.current.style.display='block';
                shouldSubmit = false;
            }

            // Grab todays date and set hours to exactly midnight
            const todaysDate = new Date();
            todaysDate.setHours(0,0,0,0);

            // Grab entered effective date at midnight
            const eDate = new Date(state.effective_date + ' 00:00:00');

            // Add 1 business day to today's date
            const newDate = new Date(addBusinessDays(todaysDate, 1));
            
            // Date is today or earlier
            if(eDate.getTime() < newDate.getTime()){
                refDateError.current.innerHTML = 'Please choose a date at least 1 business day in the future.';
                refNextDay.current.checked = false;
                refDateCharge.current.classList.remove("show");
                refDate.current.classList.add('error-outline');
                refDateError.current.style.display='block';
                shouldSubmit = false;
            }

            // Date is only 1 business day in the future
            // Add next day messaging
            if(eDate.getTime() === newDate.getTime()){
                nextDay = true;
                if(!refNextDay.current.checked){
                    refDate.current.classList.add('error-outline');
                    refDateCharge.current.classList.add("show");
                    shouldSubmit = false;
                }
            }
        }

        // Customer Number Validation (Only for Admin or Sales)
        if(user.role === 'admin' || user.role === 'sales'){
            // VeraCore Product ID Validation
            if(state.vc_product_id === ''){
                refVeraCoreError.current.innerHTML = 'Please enter the VeraCore Product ID.';
                refVeraCore.current.classList.add('error-outline');
                refVeraCoreError.current.style.display='block';
                shouldSubmit = false;
            }

            // VeraCore Product ID RegEx
            if(state.vc_product_id !== ''){
                const regex = /^[0-9A-Za-z-]+$/
                if(!state.vc_product_id.match(regex)){
                    refVeraCoreError.current.innerHTML = 'Only numbers, letters and dashes are allowed in the part number.';
                    refVeraCore.current.classList.add('error-outline');
                    refVeraCoreError.current.style.display='block';
                    shouldSubmit = false;
                }
            }
            
            // Portal Selection Validation
            if(refPortal.current.value.indexOf('Select an') !== -1){
                refPortal.current.classList.add('error-outline');
                refPortalError.current.style.display='block';
                shouldSubmit = false;
            }else{
                // Grab Company Name from Clients Table
                let requestOptions = {
                    method: 'GET',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' }
                };

                let response = await fetch('https://picform.lahlouhonline.com/api/client/' + state.customer_number, requestOptions)
                let data = await response.json();
                if(!data.error){
                    companyName = data.name;
                }
            }
        // Add Company Name for Teams Message when role = External
        }else{
            let requestOptions = {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' }
            };

            let response = await fetch('https://picform.lahlouhonline.com/api/client/' + user.customer_number, requestOptions)
            let data = await response.json();
            if(!data.error){
                companyName = data.name;
            }else{
                companyName = 'Unknown';
            }
        }

        // Passed all form validation, submit to Teams
        //if(shouldSubmit){
        
        // Group Request Code
        if(shouldSubmit && confirm === null){
            confirmOverlay();
            return;
        }

        // Passed all form validation, submit to Teams
        // Group Request Version
        if(shouldSubmit && confirm != null){
            // Show overlay
            showLoading();
            let response;
            let data;
            
            // Create request object with the default fields
            const requestObj = {
                action: state.action,
                request_status: "Received",
                inventory: state.inventory,
                submitter_email: user.username,
                group_request: ""
            }

            if(user.role === 'external'){
                requestObj.request_status = 'In Review';
            }
            
            if(state.partnum) requestObj.partnum = state.partnum
            if(state.name) requestObj.name = state.name.trim();
            if(state.effective_date) requestObj.effective_date = state.effective_date
            if(refNextDay.current){
                if(refNextDay.current.checked && nextDay) requestObj.next_day = "yes";
            }
            if(refHoldDate.current){if(refHoldDate.current.checked) requestObj.hold_date = "yes";}
            if(state.client_notes) requestObj.client_notes = state.client_notes
            if(state.vc_product_id) requestObj.vc_product_id = state.vc_product_id
            if(state.customer_number){
                requestObj.customer_number = state.customer_number
            }else{
                requestObj.customer_number = user.customer_number
            }

            // Group Request Code
            if(confirm === true || pending) requestObj.request_status = 'Pending'
            
            // Submit to PICDB
            let requestOptions = {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestObj)
            };
            
            response = await fetch('https://picform.lahlouhonline.com/api/requests', requestOptions)

            if(response.status === 403){
                hideLoading();
                infoModal("You've been logged out", "You must be logged in to complete this action. Please refresh the page and log back in.")
            }else{
                data = await response.json()

                let teamsTitle, teamsType;
                if(companyName.indexOf('Test Portal') !== -1){
                    teamsTitle = 'Portal Item Change Request (Test)';
                    teamsType = 'Test - Do not process';
                }else{
                    teamsTitle = 'Portal Item Change Request';
                    teamsType = 'New Request';
                }

                if(data.name){
                    // Teams Message
                    const teamsObj =
                    {
                        "@context": "https://schema.org/extensions",
                        "@type": "MessageCard",
                        "themeColor": "0076D7",
                        "summary": "Summary",
                        "sections": [
                            {
                                "activityTitle": teamsTitle,
                                "facts": [
                                    {
                                        "name": "Type:",
                                        "value": teamsType
                                    },
                                    {
                                        "name": "Action:",
                                        "value": state.action
                                    },
                                    {
                                        "name": "Company:",
                                        "value": companyName
                                    },
                                    {
                                        "name": "Submitted By:",
                                        "value": requestObj.submitter_email
                                    },
                                    {
                                        "name": "Role:",
                                        "value": user.role
                                    },
                                    {
                                        "name": "Effective Date:",
                                        "value": formatDatePicker(new Date(state.effective_date))
                                    }
                                ],
                                "text": "https://picform.lahlouhonline.com/request?id=" + data.id
                            }
                        ]
                    }

                    // Send to Teams
                    requestOptions = {
                        method: 'POST',
                        credentials: 'include',
                        //mode: 'no-cors',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(teamsObj)
                    };
                
                    // Send Teams Message
                    // Not for external clients / test portal / pending
                    if(user.role !== 'external' && requestObj.request_status !== "Pending"){
                        fetch('https://picform.lahlouhonline.com/api/teams/' + data.id, requestOptions)
                    }

                    hideLoading();
                }
            }
        }

        // Group Request Code
        if(shouldSubmit){
            if(confirm){
                closePopup();
                navigate('/')
                return;
            } 
            if(pending){
                infoModal("Pending Requests", "You have pending requests. Redirecting to the 'Requests' page.")    
                setTimeout(() => {
                    closePopup();
                    navigate('/requests')
                    return;
                }, 2850);
            }else{
                closePopup();
                navigate('/thankyou', { state: { type: 'request' } });
                return;
            }
        }else{
            if(refErrors.current) refErrors.current.classList.add('show');
        }
    }
    
    // Informational Modal
    function infoModal(heading, content, duration = null){
        // Duration is in ms
        modalHeading.current.innerHTML = heading;
        modalContent.current.innerHTML = content;
        let scrollbarWidth = window.innerWidth - document.body.clientWidth;
        document.body.style.overflow = "hidden";
        document.body.style.marginRight = scrollbarWidth + 'px';
        overlay.current.className = 'show';
        popup.current.className = 'show';
        if(duration && duration > 0){
           setTimeout(() => {
             document.body.style.overflow = "auto";
             document.body.style.marginRight = '0';
             overlay.current.className = '';
             popup.current.className = '';
           }, duration)
        }
    }

    // Modal functionality
    function showModal(e){
        e.preventDefault();
        modalHeading.current.innerHTML = e.target.innerHTML;
        modalContent.current.innerHTML = e.target.title;
        
        let scrollbarWidth = window.innerWidth - document.body.clientWidth;
        document.body.style.overflow = "hidden";
        document.body.style.marginRight = scrollbarWidth + 'px';

        overlay.current.className = 'show';
        popup.current.className = 'show';
    }

    function showLoading(){
        let scrollbarWidth = window.innerWidth - document.body.clientWidth;
        document.body.style.overflow = "hidden";
        document.body.style.marginRight = scrollbarWidth + 'px';
        if(loadingOverlay.current) loadingOverlay.current.className = 'show';
    }

    function hideLoading(){
        document.body.style.overflow = "auto";
        document.body.style.marginRight = '0';
        if(loadingOverlay.current) loadingOverlay.current.className = '';
    }

    function closePopup(){
        document.body.style.overflow = "auto";
        document.body.style.marginRight = '0';
        if(overlay.current) overlay.current.className = '';
        if(popup.current) popup.current.className = '';
        if(popupConfirm.current) popupConfirm.current.className = '';
    }
    
    function addBusinessDays(date, add){
        for (let i = 1; i <= add; i++) {
            date.setDate(date.getDate() + 1);
            if (date.getDay() === 6) {
                date.setDate(date.getDate() + 2);
            }
            else if (date.getDay() === 0) {
                date.setDate(date.getDate() + 1);
            }
        }

        return date;
    }

    useEffect(() => {
        // Verify JWT Token
        const verifyUser = async () => {
            const requestOptions = {
                method: 'POST',
                credentials: 'include',
            };
      
            let response = await fetch('https://picform.lahlouhonline.com/api/verify', requestOptions);
            let data = await response.json()
            if(data.username){
                let todaysDate = new Date();
                todaysDate.setHours(0,0,0,0);
                const newDate = new Date(addBusinessDays(todaysDate, 1)).toISOString().split('T')[0];
                // Datepicker - 1 business day in the future, gray out past days
                refDate.current.setAttribute('min', newDate);
                //refDate.current.value = newDate;

                let requestOptions = {
                    method: 'GET',
                    credentials: 'include',
                };

                let response = await fetch('https://picform.lahlouhonline.com/api/clients', requestOptions);
                let data = await response.json()

                // Pull in Portal List
                if(data){
                    // Build Portal Select Dropdown
                    let option;
                    for(let a=0;a<data.length;a++){
                        if(data[a].active === 1){
                            option = document.createElement("option");
                            option.text = data[a].name;
                            option.value = data[a].customer_number;
                            refPortal.current.add(option);
                        }
                    }

                    // Build 'My Portals' list
                    if(refPortalList.current){
                        let li, anchor;
                        let split = user.customer_number.split(',');
                        for(let a=0;a<split.length;a++){
                            for(let b=0;b<data.length;b++){
                                if(split[a] == data[b].customer_number && data[b].active === 1){
                                    li = document.createElement('li');
                                    li.value = data[b].customer_number;
                                    anchor = document.createElement('a');
                                    anchor.setAttribute('title','Set to ' + data[b].name);
                                    anchor.onclick = setDropdown;
                                    anchor.appendChild(document.createTextNode(data[b].name))
                                    li.appendChild(anchor);
                                    refPortalList.current.appendChild(li);
                                    break;
                                }
                            }
                        }
                    }
                }

                // Check to see if logged in user has any pending requests
                response = await fetch('https://picform.lahlouhonline.com/api/requests', requestOptions)
                data = await response.json();
                if(data){
                    // Filter to only pending requests for current user
                    let myPending = data.filter(item => item.request_status === 'Pending' && item.submitter_email === user.username);
                    if(myPending && myPending.length >0){
                        setPending(true)
                    }
                }
            }else{
                await setUser(null)
            }
        }
        verifyUser();
    }, [])

    useEffect(() => {
        if(confirm === true || confirm === false) handleSubmit()
    }, [confirm]);

    function setDropdown(e){
        let value = e.target.parentNode.getAttribute('value')
        const items = refPortal.current.options;

        for(let a=0;a<items.length;a++){
            if(items[a].value === value){
                items[a].selected = true;
                setState(prevState => ({
                    ...prevState,
                    ['customer_number']: value
                }));
                break;
            }
        }
    }
    
    if(!user) return null

    return (
    <>
    <div className="main">
        <div className="main-content">
            <h1 className="mt10">Remove Item</h1>

            <div className="mt20 center">
                Hover or click on a heading to see additional information when available.
            </div>

            <div className="mt10 center">
                Required information is marked with an asterisk (<span className="required"></span>)
            </div>

            <div className="form-header slate-bg mt20"></div>
            
            <div className={user.role === 'admin' || user.role === 'sales' ? "form-top" : "form-bottom"}>
                {/* Portal Selection */}
                {user.role !== 'external' &&
                <div className="element">
                    <label className="required">Portal Selection</label>

                    {user.customer_number.split(',')[0] !== '1' && user.role === 'sales' &&
                    <div className="portal-list-wrapper padLeft8">
                        <strong>My Portals</strong>
                        <ul ref={refPortalList} className="portal-list mt5">
                        </ul>
                    </div>
                    }

                    <select 
                        name="customer_number"
                        ref={refPortal}
                        value={state.customer_number} 
                        onChange={handleChange}
                    >
                        <option>Select an option...</option>
                    </select>

                    <div ref={refPortalError} className="errorMessage">
                        Please select a portal.
                    </div>
                </div>
                }
                
                {/* Action */}
                <div className="element">
                    <label className="required">Action</label>
                    <select 
                        name="action"
                        ref={refAction}
                        value={state.action} 
                        onChange={handleChange}
                    >
                        <option>Select an option...</option>
                        <option>Remove Item</option>
                        <option>Remove & Deactivate</option>
                    </select>

                    <div ref={refActionError} className="errorMessage">
                        Please select an action.
                    </div>
                </div>

                {/* Inventory */}
                <div className="element">
                    <label className="required">Physical Inventory</label>
                    <select 
                        name="inventory"
                        ref={refInventory}
                        value={state.inventory}
                        onChange={handleChange}
                    >
                        <option>Select an option...</option>
                        <option>No Inventory on Hand</option>
                        <option>Keep on Hand</option>
                        <option>Remove & Destroy</option>
                        <option>Ship as Instructed</option>
                    </select>

                    <div ref={refInventoryError} className="errorMessage">
                        Please select an inventory option.
                    </div>
                </div>
                
                {/* Client Part Number */}
                <div className="element">
                    <div className="tooltiptext">
                        {user.role !== 'external'
                        ? "Enter the client part number, which usually matches the Veracore Product ID."
                        : "Enter the part number."
                        }
                    </div>
                    <label 
                        className="required" 
                        // title={user.role !== 'external'
                        //     ? "Enter the client part number, which usually matches the Veracore Product ID." 
                        //     : "Enter the part number." 
                        // }
                        //onClick={event => showModal(event)}
                    >
                        {user.role !== 'external' && "Client " }Part No. (SKU)
                    </label>
                    <input 
                        name="partnum"
                        ref={refPartNum}
                        type="text"
                        value={state.partnum}
                        onChange={handleChange}
                    />
                    <div ref={refPartNumError} className="errorMessage"></div>
                </div>
                
                {/* Product Title */}
                <div className="element">
                    <div className="tooltiptext">
                        Enter the product title as it appears on the portal.
                    </div>
                    <label
                        className="required"
                        //title="Enter the product title as it appears on the portal."
                        //onClick={event => showModal(event)}
                    >
                        Product Title
                    </label>
                    <input 
                        name="name"
                        ref={refName}
                        type="text"
                        min="2022-11-06"
                        value={state.name}
                        onChange={handleChange}
                    />
                    <div ref={refNameError} className="errorMessage">
                        Please enter a product title.
                    </div>
                </div>

                {/* Effective Date */}
                <div className="element">
                    <div className="tooltiptext">
                        Change could go live sooner than this date depending on the teams workload. Check the 'Hold until effective date' checkbox if needed.
                    </div>
                    <label 
                        className={user.role !== "external" ? "required" : undefined} 
                        //title="Change could go live sooner than this date depending on the teams workload. Check the 'Hold until effective date' checkbox if needed." 
                        //onClick={event => showModal(event)}
                    >Effective Date</label>
                    <input 
                        name="effective_date"
                        ref={refDate}
                        type="date"
                        value={state.effective_date}
                        onChange={handleChange}
                        onKeyDown={(e) => e.preventDefault()}
                    />

                    <div ref={refDateError} className="errorMessage"></div>

                    <div ref={refDateCharge} className="radio-check-wrapper next-day-message">
                      <label className="checkbox-container no-highlight">
                            <input 
                                ref={refNextDay}
                                type="checkbox"
                                name="next-day-check"
                                id="next-day"
                                value={state.next_day}
                                onChange={handleChange}
                            />
                            <span className="checkmark"></span>
                            Next day service may incur an additional charge.
                        </label>
                    </div>

                    {/* Hold Date */}
                    <div className="radio-check-wrapper mt10">
                        <label className="checkbox-container no-highlight">
                            <input 
                                ref={refHoldDate}
                                type="checkbox"
                                name="hold-date-check"
                                id="hold-date"
                                //value="yes"
                                //value={state.hold_date}
                                //checked={state.hold_date === 'yes'}
                                onChange={handleChange}
                            />
                            <span className="checkmark"></span>
                            Hold until effective date
                        </label>
                    </div>
                </div>
                {/* End of Effective Date */}

                {/* Product Notes */}
                <div className="element">
                    <div className="tooltiptext">
                        Enter any notes that will aid in the removal of this product.
                    </div>
                    <label 
                        //title="Enter any notes that will aid in the removal of this product." 
                        //onClick={event => showModal(event)}
                    >
                        Additional Product Notes
                    </label>
                    <div className="textarea-wrapper">
                        <textarea 
                            name="client_notes"
                            value={state.client_notes}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>

            {(user.role === 'admin' || user.role === 'sales') &&
            <div className="internal-content">
                <div className="form-divider yellow-bg center">
                    Lahlouh Internal
                </div>

                {/* <h2 className="center">Lahlouh Details</h2> */}
                
                <div className="admin-form-bottom">
                    {/* VeraCore Product ID */}
                    <div className="element">
                        <div className="tooltiptext">
                            This is the product ID that is assigned by Lahlouh. Ideally, it is the same as the Client Part No. (SKU) and should be included on the physical inventory item. It is included on all carton labels.
                        </div>
                        <label 
                            className="required" 
                            //title="This is the product ID that is assigned by Lahlouh. Ideally, it is the same as the Client Part No. (SKU) and should be included on the physical inventory item. It is included on all carton labels." 
                            //onClick={event => showModal(event)}
                        >
                            VeraCore Product ID #
                        </label> 
                        <input
                        type="text"
                        name="vc_product_id"
                        ref={refVeraCore}
                        value={state.vc_product_id}
                        onChange={handleChange}
                        disabled={state.request_status === 'Completed' || state.request_status === 'In Progress' ? true : false}
                        />

                        <div ref={refVeraCoreError} className="errorMessage">
                            Please enter the VeraCore Product ID.
                        </div>
                    </div>
                </div>
            </div>
            }

            <div ref={refErrors} className="small-width errorMaster center">
                There are items that require your attention above
            </div>

            <div className="submit-save-wrapper mt20 center">
                <button className="primary-button" title="Submit" onClick={handleSubmit}>Submit</button>
                {/* <button className="secondary-button" title="Save for later" onclick={handleSubmit}>Save for later</button> */}
            </div>
        </div>
    </div>

    <div id="overlay" ref={overlay}></div>

    <div id="loading-overlay" ref={loadingOverlay}>
        <div className="deadCenter">
            <div className="lds-spinner">
                <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
            </div>
        </div>
    </div>

    <div id="popup" ref={popup}>
        <h2 id="modal-heading" className="center" ref={modalHeading}></h2>
        <span id="popup-close" ref={modalClose} className="close" onClick={closePopup}>&times;</span>
        <div id="modal-content" ref={modalContent} className="content center"></div>
    </div>

    <div id="popup-confirm" ref={popupConfirm}>
        <h2 id="modal-heading" ref={popupConfirmHeading} style={{textAlign:'center'}}>Anything Else?</h2>
        <span className="close" ref={popupConfirmClose} onClick={() => {closePopup();setConfirm(null)}}>&times;</span>
        <div id="modal-content" ref={popupConfirmContent} className="content center">
          Text changed through JS
        </div>
        <div className="mt10 center">
          <button className="primary-button smaller-button" onClick={(e) => {closePopup();overlay.current.className = 'show';setConfirm(true);}} title="Yes">Yes</button>
          <button className="secondary-button smaller-button" onClick={() => {closePopup();overlay.current.className = 'show';setConfirm(false);}} title="No">No</button>
        </div>
    </div>
    </>
  )
}
